import moment from "moment";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import React, { useState, useEffect } from "react";
import Notification from "../../../components/Notification";
import OrcamentoPdf from "../../../template/pdf/orcamentos/OrcamentoPdf";
import { verificaIsDifferent } from "../../../utils/verificaOrcamentosDiferentes";
import { tipoProfissionalSaude } from "../../../utils/constants/tipoProfissionalSaude";
import ModalOrcamento from "./ModalOrcamento";
import ImpressaoHtml from "../../../components/Impressao/ImpressaoHtml";
import { existeOrcamentoComProcedimentoAndSujeitoAtencao } from "../../../services/OrcamentoService";
import {
  findConfiguracaoUnidade,
  saveOrcamento,
} from "../../../services/OdontogramaService";
import {
  defaultErrors,
  orcamentoDefault,
} from "../../../stores/Orcamento.store";
import string from "../../../utils/string";
import Procedimentos from "./Procedimentos";

const ModalOrcamentoGerenciador = observer(
  ({
    orcamentoStore,
    odontogramaStore,
    setOpenModalOrcamento,
    openModalOrcamento,
    sujeitoAtencaoSelected,
    loadList,
    orcamentoComparar,
    configuracaoImpressaoStore,
    agendamentoSelected,
    statusBack,
    prontuarioStore,
    auditoriaStore,
    setOpenModalConfirmacao,
  }) => {
    const {
      orcamento,
      handleFieldModal,
      notification,
      closeAlertMessage,
    } = orcamentoStore;

    const [configUnidade, setConfigUnidade] = useState(null);
    const [isLoadingSave, setIsLoadingSave] = useState(false);
    const [openImpressaoOrcamento, setoOpenImpressaoOrcamento] = useState(
      false
    );
    const [orcamentoPrint, setOrcamentoPrint] = useState(null);

    const {
      nome,
      convenio,
      dataVencimento,
      desconto,
      id,
      observacao,
      orcamentoProcedimentos,
      profissionalSaude,
      statusOrcamentoOdontologico,
      tipoPagamento,
      totalParcelas,
      valor,
      valorEntrada,
      orcamentista,
      profissionalExecutante,
      profissionalSolicitante,
    } = orcamento || {};

    const profissionalSaudeLogado = JSON.parse(
      localStorage[`_immortal|profissional_saude_logado`] || null
    );
    const isAdministrador =
      tipoProfissionalSaude[profissionalSaudeLogado?.tipo] === "Administrador";

    const isDisabled =
      id && !isAdministrador && statusBack?.tipo === "REPROVADO";
    const { permiteDuplicidadeOrcamento } = configUnidade || {};

    useEffect(() => {
      if (!orcamentoStore.orcamento.orcamentista) {
        orcamentoStore.orcamento.orcamentista = profissionalSaudeLogado;
      }
      getConfigUnidade();
      orcamentoStore.errors = defaultErrors;
    }, []);

    const getConfigUnidade = async () => {
      const configUnidade = await findConfiguracaoUnidade();

      setConfigUnidade(configUnidade);
    };

    const verificaErros = () => {
      const errorDesconto = orcamentoStore.errorLimiteDesconto(
        configUnidade.limiteDescontoOrcamento
      );
      const errors = {
        tipoPagamento: !tipoPagamento,
        desconto: errorDesconto,
      };

      orcamentoStore.errors = errors;

      return errors;
    };

    const handleSave = async (action = "") => {
      try {
        const errors = verificaErros();
        const possuiErros = Object.values(errors).some((item) => item);

        if (possuiErros) {
          const message = errors?.desconto
            ? "Limite de desconto ultrapassado."
            : "Favor verificar os campos obrigatórios";

          orcamentoStore.openNotification(message, "error");
          return;
        }
        setIsLoadingSave(true);
        const isOrcamentoAprovado = statusOrcamentoOdontologico?.tipo === "APROVADO";

        const procedimentosChecked = orcamentoProcedimentos.map((item) => {
          const { dente, id, mucosaOral, valorUnitario, checked, status } = item;
          const statusProcedimento = isOrcamentoAprovado ? "APROVADO" : status?.value;

          return {
            procedimentoOdontologico: {
              id,
              status: checked ? statusProcedimento : "REPROVADO",
              ...(mucosaOral && { mucosaOral }),
              ...(dente && { dente }),
            },
            valorUnitario:
              typeof valorUnitario === "string"
                ? string.currencyMaskToFloat(valorUnitario)
                : valorUnitario,
            quantidade: 1,
          };
        });

        let descontoNumber = 0;

        if (desconto?.valorDesconto) {
          descontoNumber =
            desconto?.tipoDesconto?.value === "VALOR"
              ? string.currencyMaskToFloat(desconto.valorDesconto)
              : string.removeMask(String(desconto.valorDesconto), "%");
        }

        const agendamentoId =
          agendamentoSelected?.id || orcamento?.agendamento?.id;

        const variables = {
          ...(id && { id }),
          nome,
          observacao,
          statusOrcamentoOdontologico,
          orcamentoProcedimentos: procedimentosChecked,
          valor:
            typeof valor === "string"
              ? string.currencyMaskToFloat(valor)
              : valor,
          tipo: "ODONTOLOGICO",
          profissionalSaude: {
            id: profissionalSaude?.id,
          },
          ...(totalParcelas && { totalParcelas: totalParcelas?.value }),
          ...(valorEntrada && {
            valorEntrada:
              typeof valorEntrada === "string"
                ? string.currencyMaskToFloat(valorEntrada)
                : valorEntrada,
          }),
          ...(convenio?.value && {
            convenio: { id: convenio?.value },
          }),
          ...(dataVencimento && {
            dataVencimento: moment(dataVencimento).format("YYYY-MM-DD"),
          }),
          ...(descontoNumber && {
            desconto: {
              valorDesconto: descontoNumber,
              tipoDesconto: desconto?.tipoDesconto?.value,
            },
          }),
          ...(tipoPagamento?.value && {
            tipoPagamento: tipoPagamento?.value,
          }),
          sujeitoAtencao: {
            id: sujeitoAtencaoSelected?.id,
          },
          ...(agendamentoId && {
            agendamento: {
              id: agendamentoId,
            },
          }),
          ...(orcamentista?.id && { orcamentista: { id: orcamentista.id } }),
          ...(profissionalExecutante?.id && { profissionalExecutante: {id: profissionalExecutante?.id} }),
          ...(profissionalSolicitante?.id && { profissionalSolicitante: {id: profissionalSolicitante?.id} }),
        };

          const response = await saveOrcamento(variables);
          if (response.id) {
            prontuarioStore.openNotification(
              "Orçamento salvo com sucesso!",
              "success"
            );
          }

          if (
            response?.statusOrcamentoOdontologico?.tipo === "PENDENTE_APROVACAO"
          ) {
            orcamentoStore.orcamento = orcamentoDefault;
          } else if (
            response?.statusOrcamentoOdontologico?.tipo === "APROVADO"
          ) {
            orcamentoStore.orcamento = {
              ...orcamentoStore.orcamento,
              id: response?.id,
            };
            odontogramaStore.dadosModalConfirmacao.open = true;
          }
          await loadList();

          if (
            orcamentoComparar.statusOrcamentoOdontologico?.tipo !==
              "APROVADO" &&
            response.statusOrcamentoOdontologico?.tipo === "APROVADO"
            &&
            !response.faturado
          ) {
            setOpenModalConfirmacao(true);
          }

          action !== "PRINT" && setOpenModalOrcamento(false);

          return response?.id;
        
      } catch (e) {
        orcamentoStore.openNotification("Erro ao salvar o orçamento", "error");
      } finally {
        setIsLoadingSave(false);
      }
    };

    const getOrcamentoPrint = async () => {
      const orcamentoSelecionado = { ...orcamento };
      const orcamentoComparacao = orcamentoComparar;

      if (
        verificaIsDifferent(orcamentoSelecionado, orcamentoComparacao, true)
      ) {
        const idOrcamentoUpdate = await handleSave({action: "PRINT"});
        return await orcamentoStore.getDadosOrcamentoOdontologico(
          idOrcamentoUpdate
        );
      } else {
        return orcamento;
      }
    };

    const handlePrint = async () => {
      try {
        await configuracaoImpressaoStore.getConfig("ORCAMENTO");
        let orcamentoPrint = await getOrcamentoPrint();

        const isAprovedAndPossuiProcedimentoSelecionado = orcamentoPrint?.statusOrcamentoOdontologico?.tipo === "APROVADO" &&
          orcamentoPrint?.orcamentoProcedimentos.some((procedimento) => procedimento.checked)

        let orcamentoProcedimentos = isAprovedAndPossuiProcedimentoSelecionado ? orcamentoPrint?.orcamentoProcedimentos.filter(
          (item) => item.checked
        ) : orcamentoPrint?.orcamentoProcedimentos

        const orcamentoImprimir = { ...orcamentoPrint, orcamentoProcedimentos };
        setOrcamentoPrint(orcamentoImprimir);
        setoOpenImpressaoOrcamento(true);
      } catch (e) {
        console.error(e);
      }
    };

    const handleCloseModal = () => {
      auditoriaStore.auditoriaProps = {
        ...auditoriaStore.auditoriaProps,
        pageNumber: 0,
        lastPage: false,
        auditorias: [],
      };
      setOpenModalOrcamento(false);
    };

    return (
      <>
        <ModalOrcamento
          open={openModalOrcamento}
          onClose={() => handleCloseModal()}
          title={id ? "Editar orçamento" : "Emitir orçamento"}
          handleSave={handleSave}
          orcamento={orcamento}
          handleFieldModal={handleFieldModal}
          isLoadingSave={isLoadingSave}
          setIsLoadingSave={setIsLoadingSave}
          handlePrint={handlePrint}
          sujeitoAtencaoSelected={sujeitoAtencaoSelected}
          statusBack={statusBack}
        >
          <Procedimentos
            isDisabled={isDisabled}
            orcamento={orcamento}
            handleFieldModal={handleFieldModal}
          />
        </ModalOrcamento>
        {openImpressaoOrcamento && (
          <ImpressaoHtml
            handlePrintMustache={() => setoOpenImpressaoOrcamento(false)}
            habilitaBotaoImpressao={setOpenModalOrcamento}
            isPrintMustache={openImpressaoOrcamento}
            htmlStringComponent={<OrcamentoPdf orcamento={orcamentoPrint} />}
          />
        )}
        <Notification
          close={closeAlertMessage}
          reset={closeAlertMessage}
          isOpen={notification.isOpen}
          variant={notification.variant}
          message={notification.message}
        />
      </>
    );
  }
);

export default inject(
  "odontogramaStore",
  "orcamentoStore",
  "configuracaoImpressaoStore",
  "prontuarioStore",
  "auditoriaStore"
)(ModalOrcamentoGerenciador);
